export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Analyse et Étude',
      description: 'Rencontre initiale pour comprendre vos besoins spécifiques, analyse du site, étude de faisabilité technique et financière. Proposition détaillée avec plans préliminaires et devis transparent.',
      duration: '1-2 semaines',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Conception Détaillée',
      description: 'Élaboration des plans d\'exécution complets, schémas électriques unifilaires et multifilaires, calculs de dimensionnement, choix des équipements et validation avec architectes et maîtres d\'ouvrage.',
      duration: '2-4 semaines',
      icon: 'ri-draft-line'
    },
    {
      number: '03',
      title: 'Validation et Autorisations',
      description: 'Soumission des dossiers techniques aux autorités compétentes, obtention des autorisations nécessaires, coordination avec les services industriels et validation finale avant démarrage des travaux.',
      duration: '2-3 semaines',
      icon: 'ri-file-check-line'
    },
    {
      number: '04',
      title: 'Réalisation des Travaux',
      description: 'Installation professionnelle selon planning établi, coordination avec autres corps de métier, contrôles qualité réguliers, respect strict des normes OIBT/NIBT et communication transparente sur l\'avancement.',
      duration: 'Variable',
      icon: 'ri-hammer-line'
    },
    {
      number: '05',
      title: 'Tests et Mise en Service',
      description: 'Tests complets de toutes les installations, mesures de conformité OIBT, réglages fins des systèmes, vérification de la sécurité et optimisation des performances avant livraison officielle.',
      duration: '1-2 semaines',
      icon: 'ri-test-tube-line'
    },
    {
      number: '06',
      title: 'Livraison et Formation',
      description: 'Remise de la documentation technique complète (plans as-built, certificats, manuels), formation des utilisateurs aux systèmes installés, garanties et mise en place du service après-vente.',
      duration: '1 semaine',
      icon: 'ri-graduation-cap-line'
    }
  ];

  return (
    <section id="processus" className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Notre Processus</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Un Processus Structuré et Transparent
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            De la première rencontre à la livraison finale, chaque étape est planifiée et exécutée avec rigueur pour garantir votre satisfaction.
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-teal-600 via-teal-400 to-teal-600 hidden lg:block"></div>
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                  <div className="lg:col-span-1 flex justify-center lg:justify-start mb-4 lg:mb-0">
                    <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-full text-white font-bold text-xl shadow-lg relative z-10">
                      {step.number}
                    </div>
                  </div>
                  <div className="lg:col-span-11">
                    <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                            <i className={`${step.icon} text-2xl text-teal-600`}></i>
                          </div>
                          <h3 className="text-2xl font-bold text-gray-900">{step.title}</h3>
                        </div>
                        <span className="bg-teal-100 text-teal-700 px-4 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                          {step.duration}
                        </span>
                      </div>
                      <p className="text-gray-600 leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl font-bold mb-4">Interventions Rapides Garanties</h3>
          <p className="text-lg mb-6 max-w-3xl mx-auto">
            Nous nous engageons à respecter les délais convenus et à intervenir rapidement en cas d'urgence. Notre réactivité est l'un de nos atouts majeurs pour la satisfaction de nos clients.
          </p>
          <div className="flex flex-wrap justify-center gap-8">
            <div>
              <div className="text-4xl font-bold">24/7</div>
              <div className="text-teal-100 mt-1">Service d'urgence</div>
            </div>
            <div>
              <div className="text-4xl font-bold">&lt; 2h</div>
              <div className="text-teal-100 mt-1">Temps de réponse</div>
            </div>
            <div>
              <div className="text-4xl font-bold">98%</div>
              <div className="text-teal-100 mt-1">Respect des délais</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
